<template>
  <md-dialog :md-active="isOpen" class="modalEdit__instructors">
    <div class="w-100 position-fixed mobile-cancel">
      <span
        class="material-icons close text-right"
        @click="closeDialog"
      >close</span
      >
    </div>
    <div class="body-modal-instructor modal-body">
      <div class="md-dialog-title text-left">
        <h3 class="text-bold">EDITAR VIDEO</h3>
      </div>
      <div class="form-instructor dialog-body">
        <div class="col-md-12 px-0">
          <base-input v-model="video.title"></base-input>
        </div>
        <h4 class="mt-4 text-bold text-left">FOTO DEL VIDEO</h4>
        <div class="dropzone-header-instructor">
          <md-field class="pt-0">
            <md-file
              :style="{
                backgroundImage: `url('${video.thumbnail}')`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: '100% 100%',
                borderRadius: '0.25rem',
              }"
              accept="image/*"
              class="design-dropzone"
              @md-change="changeThumbnail($event)"
            />
          </md-field>
        </div>
        <div>
          <h4 class="mt-4 text-bold text-left">VIDEO</h4>
          <div class="progress progress-show-courses">
            <div
              v-if="this.progress > 0 && this.progress < 100"
              :aria-valuenow="this.progress"
              :style="{ width: this.progress + '%' }"
              aria-valuemax="100"
              aria-valuemin="0"
              class="progress-bar"
              role="progressbar"
            ></div>
            <div
              v-else-if="this.progress === 100 || this.progress === 0"
              :aria-valuenow="'0'"
              :style="{ width: '0%' }"
              aria-valuemax="100"
              aria-valuemin="0"
              class="progress-bar"
              role="progressbar"
            ></div>
          </div>
          <vue-dropzone
            id="updateVideoDropzone"
            ref="updateVideoDropzone"
            :options="dropzoneOptions"
            @vdropzone-file-added="fileAdded"
            @vdropzone-success="successUpload"
          ></vue-dropzone>
        </div>
        <md-dialog-actions
          class="modal-footer"
          style="flex-flow: inherit !important"
        >
          <base-button
            class="md-primary w-auto"
            type="secondary"
            @click="closeDialog"
          >CANCELAR
          </base-button>
          <base-button
            :loading="isLoading"
            class="md-primary w-auto"
            type="primary"
            @click="submit"
          >ACTUALIZAR
          </base-button>
        </md-dialog-actions>
      </div>
    </div>
  </md-dialog>
</template>

<script>
import config from '@/config/config';
import vue2Dropzone from 'vue2-dropzone';
import { BUNNY_ACCESS_KEY_ID, DEFAULT_VIDEO_VALUES, LIBRARY_BUNNY_ID } from '@/util/constants';
import { sha256 } from 'js-sha256';
import * as tus from 'tus-js-client';
import axios from 'axios';

export default {
  name: 'UpdateVideoDialog',

  components: {
    vueDropzone: vue2Dropzone,
  },
  props: {
    selectedVideo: {
      type: Object,
      default: () => {},
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['success', 'close-dialog'],
  data () {
    return {
      isLoading: false,
      progress: 0,
      video: DEFAULT_VIDEO_VALUES,
      dropzoneOptions: {
        url: `/no-upload-needed`,
        thumbnailWidth: 150,
        maxFilesize: 9999999,
        timeout: 9999999,
        addRemoveLinks: true,
        uploadMultiple: true,
        acceptedFiles: 'video/mp4,video/x-m4v,video/*',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('user-token'),
        },
        autoProcessQueue: false,
      },
      file: null,

    };
  },
  mounted () {
    this.video = this.selectedVideo ?? DEFAULT_VIDEO_VALUES;
  },
  updated () {
    this.video = this.selectedVideo ?? DEFAULT_VIDEO_VALUES;
  },
  methods: {
    getQueuedFile (fileId = null) {
      const dropzoneInstance = this.$refs.updateVideoDropzone.dropzone;
      if (!dropzoneInstance) return null;

      const queuedFiles = dropzoneInstance.getQueuedFiles();
      if (fileId) {
        return queuedFiles.find(file => file.upload.uuid === fileId);
      }
      return queuedFiles.length > 0 ? queuedFiles[0] : null;
    },

    updateProgressFile (fileId, progress) {
      const fileToUpdate = this.getQueuedFile(fileId);
      if (fileToUpdate) {
        const dropzoneInstance = this.$refs.updateVideoDropzone.dropzone;

        dropzoneInstance.emit('uploadprogress', fileToUpdate, progress);
      } else {
        console.warn(`No se encontró el archivo con ID ${fileId} en la cola.`);
      }
    },
    async createBunnyVideo (filename) {
      const url = `https://video.bunnycdn.com/library/${LIBRARY_BUNNY_ID}/videos`;
      const response = await axios.post(url,
        {
          title: filename,
        }, {
          headers: {
            accept: 'application/json',
            'content-type': 'application/json',
            AccessKey: BUNNY_ACCESS_KEY_ID,
          },
        });
      return response.data;
    },
    async fileAdded (file) {
      this.file = file;
    },
    successUpload () {
      this.$refs.updateVideoDropzone.removeAllFiles();
    },

    closeDialog () {
      this.$emit('close-dialog');
    },
    async updateBunnyVideo () {
      this.isLoading = true;
      const file = this.file;
      if (!file) {
        try {

          await this.updateVideo(this.video.title || 'Sin titulo', undefined, undefined, undefined);
          this.notify('success', 'Se video se actualizo correctamente!');
          this.$emit('success');
          this.isLoading = false;
          this.closeDialog();

        } catch (e) {
          this.notify('error', 'Tenemos problema para actualizar el video');
          this.isLoading = false;
        }

      } else {

        const bunnyVideo = await this.createBunnyVideo(file.name);

        if (!bunnyVideo) {
          return null;
        }

        const vm = this;

        const videoGuid = bunnyVideo.guid;
        const presignedSignature = sha256(LIBRARY_BUNNY_ID + BUNNY_ACCESS_KEY_ID + 99999999999 + videoGuid);
        const fileId = file.upload.uuid || null;
        var upload = new tus.Upload(file, {
          endpoint: 'https://video.bunnycdn.com/tusupload',
          retryDelays: [0, 3000, 5000, 10000, 20000],
          headers: {
            AuthorizationSignature: presignedSignature, // SHA256 signature (library_id + api_key + expiration_time + video_id)
            AuthorizationExpire: 99999999999, // Expiration time as in the signature,
            VideoId: videoGuid, // The guid of a previously created video object through the Create Video API call
            LibraryId: LIBRARY_BUNNY_ID,
          },
          metadata: {
            filetype: file.type,
            title: file.name,
          },
          onError: function(error) {
            console.log({ error });
            vm.notify('danger', `Tenemos problemas para carga el video: ${file.name}`);
          },
          onProgress: function(bytesUploaded, bytesTotal) {
            const progress = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
            // vm.progress = progress;
            vm.updateProgressFile(fileId, progress);

          },
          onSuccess: async function() {
            console.log('success');
            const filename = vm.video.title || file?.filename;
            await vm.updateVideo(filename, file?.type, videoGuid, file?.size);
            vm.notify('success', 'Se video se actualizo correctamente!');
            vm.$emit('success');
            vm.isLoading = false;
            vm.closeDialog();

          },
        });

        upload.findPreviousUploads().then(function(previousUploads) {
          // Found previous uploads so we select the first one.
          if (previousUploads.length) {
            upload.resumeFromPreviousUpload(previousUploads[0]);
          }

          // Start the upload
          upload.start();
        });
      }

    },
    async updateVideo (filename, extension, guid, size) {
      const id = this.video.id;

      const response = await axios.post(`${config.data.apiUrl}/admin/video/upload/${id}`,
        {
          extension,
          filename,
          guid,
          size,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('user-token'), // the token is a variable which holds the token
          },
        });
      return response.data;
    },
    async submit () {
      await this.updateBunnyVideo();
    },
    notify (type, message) {
      this.$notify({
        type: type,
        verticalAlign: 'top',
        horizontalAlign: 'right',
        message: message,
      });
    },
    changeThumbnail (files) {
      this.video.thumbnail = URL.createObjectURL(files[0]);
      this.file = files[0];
    },
  },
};
</script>

<style scoped></style>
